var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "passenger-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg passenger",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "passenger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,21.43a8.08,8.08,0,0,1,5.68-2.29H22.48a8.26,8.26,0,0,1,5.68,2.29,8.07,8.07,0,0,1,2.29,5.69v3.19a1.69,1.69,0,0,1-3.38,0V27.12a5.39,5.39,0,0,0-1.4-3.39,4.51,4.51,0,0,0-3.39-1.4H9.72a5.41,5.41,0,0,0-3.39,1.4,4.49,4.49,0,0,0-1.4,3.39v3.19A1.74,1.74,0,0,1,3.24,32a1.74,1.74,0,0,1-1.69-1.69V27.12A9.2,9.2,0,0,1,4,21.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,3.19A4.86,4.86,0,0,0,11.31,8a4.85,4.85,0,0,0,4.79,4.78A4.93,4.93,0,0,0,21,8,4.74,4.74,0,0,0,16.1,3.19ZM8.12,8a8,8,0,1,1,8,8A8,8,0,0,1,8.12,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a1e01f8ab3026d39ffa8ae38cf2c1132.svg";
export { ForwardRef as ReactComponent };